import React from "react";

import "./styles.css";

const SubscriptionCardLabel = ({ ticketsAmount }) => {
  return (
    <div className="subscription-card__label">
     <svg
        width="237"
        height="143"
        viewBox="0 10 60 65"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g x="50" y="20" transform="rotate(25, 0, 0)">
          <path
            d="M12.2976 19.0245C8.91474 22.4073 8.91475 27.9115 12.2976 31.2944C15.6804 34.6772 21.1846 34.6772 24.5675 31.2944C27.9503 27.9115 27.9503 22.4073 24.5675 19.0245C21.1846 15.6417 15.6804 15.6417 12.2976 19.0245ZM22.3365 29.0634C20.1838 31.2161 16.6811 31.2162 14.5283 29.0634C12.3757 26.9107 12.3756 23.4081 14.5283 21.2553C16.6811 19.1025 20.1837 19.1025 22.3365 21.2553C24.4893 23.4081 24.4892 26.9107 22.3365 29.0634Z"
            fill="#043B3B"
          ></path>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M76.1387 7.24416L76.1388 41.9597C76.1392 43.6964 74.7252 45.1092 72.9875 45.1088L22.501 45.1089C20.3534 45.109 17.4171 43.6809 16.0888 41.9905L4.58453 27.3486C3.41461 25.8598 3.41461 23.3441 4.58452 21.8553L16.0887 7.21337C17.3948 5.55227 20.3904 4.09496 22.5011 4.09486L72.9876 4.09485C73.8273 4.09465 74.6182 4.42382 75.215 5.0216C75.8107 5.61816 76.1387 6.4075 76.1387 7.24416ZM12.2976 31.2944C8.91475 27.9115 8.91474 22.4073 12.2976 19.0245C15.6804 15.6417 21.1846 15.6417 24.5675 19.0245C27.9503 22.4073 27.9503 27.9115 24.5675 31.2944C21.1846 34.6772 15.6804 34.6772 12.2976 31.2944Z"
            fill="#043B3B"
          ></path>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M72.9876 0.9395L22.5009 0.939717C19.4193 0.939615 15.5129 2.83946 13.6079 5.26385L2.10371 19.9058C0.0347508 22.539 0.0347537 26.6644 2.10371 29.2977L13.6079 43.9397C15.5132 46.3645 19.4196 48.2639 22.5011 48.264L72.9875 48.2639C74.6649 48.2639 76.246 47.6086 77.4389 46.4189L77.4455 46.4123C78.6373 45.2205 79.2938 43.6395 79.294 41.9597L79.2939 7.24415C79.2937 5.56592 78.6382 3.98496 77.4478 2.79247C76.2548 1.59762 74.671 0.939603 72.9876 0.9395ZM76.1388 41.9597L76.1387 7.24416C76.1387 6.4075 75.8107 5.61816 75.215 5.0216C74.6182 4.42382 73.8273 4.09465 72.9876 4.09485L22.5011 4.09486C20.3904 4.09496 17.3948 5.55227 16.0887 7.21337L4.58452 21.8553C3.41461 23.3441 3.41461 25.8598 4.58453 27.3486L16.0888 41.9905C17.4171 43.6809 20.3534 45.109 22.501 45.1089L72.9875 45.1088C74.7252 45.1092 76.1392 43.6964 76.1388 41.9597Z"
            fill="#043B3B"
          ></path>
          <g>
            <text
              x="50"
              y="20"
              text-anchor="middle"
              font-size="16"
              font-weight="bold"
              fill="#fff"
            >
              +{ticketsAmount}
            </text>
            <text x="47" y="30" text-anchor="middle" font-size="12" fill="#fff">
              extra
            </text>
            <text x="50" y="40" text-anchor="middle" font-size="12" fill="#fff">
              tickets
            </text>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default SubscriptionCardLabel;
